var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { cssColorValue, desktopMestoBold, NavBar, NavBarList, screenMdMin, spacer32, } from '@spotify-internal/encore-web';
import styled from 'styled-components';
import { FrodorTextLink } from '../Link/Link';
import { hexToRgba } from '../../utils/colorConversion';
import { trackCat } from './constants';
import { isMastheadCategoryMenu, isMastheadGalleryMenu, isMastheadLink, isMastheadLinkList, isMastheadLinkListItem, } from '../../utils/contentful';
import { trackingAttributes } from '../../lib/buildTrackingAttributes';
import { isNotUndefined } from '../../lib/isNotUndefined';
import { useActiveSubmenu } from '../ActiveSubmenu/ActiveSubmenuProvider';
import { S4XDropdown } from './S4XDropdown';
import { SubmenuTrigger } from './FlyoutMenu/Trigger';
const StyledNavBar = styled(NavBar) `
  @media (max-width: ${screenMdMin}) {
    display: none;
  }
`;
const StyledNavBarList = styled(NavBarList) `
  gap: ${spacer32};
  line-height: 24px;
  margin: 0;
  overflow-x: visible;
  padding: 0;
  ${desktopMestoBold};
  li {
    display: flex;
    align-items: center;
  }
`;
const NavLink = styled(FrodorTextLink) `
  cursor: pointer;
  ${desktopMestoBold};

  && {
    color: ${props => { var _a; return hexToRgba(((_a = props.colors) === null || _a === void 0 ? void 0 : _a.text) || cssColorValue('textBase'), 0.75); }};
    text-decoration: none;

    &:active,
    &:hover,
    &:focus {
      color: ${props => { var _a; return ((_a = props.colors) === null || _a === void 0 ? void 0 : _a.text) || cssColorValue('textBase'); }};
      text-decoration: none;
    }
  }
`;
const NavbarDropdown = (_a) => {
    var { id } = _a, props = __rest(_a, ["id"]);
    const { activeSubmenu, claimActiveSubmenu, clearActiveSubmenu } = useActiveSubmenu(id);
    return (React.createElement(S4XDropdown, Object.assign({ onOpen: claimActiveSubmenu, onClose: clearActiveSubmenu, opened: activeSubmenu ? activeSubmenu === id : false }, props)));
};
const buildPopoverLinkItems = (linkListItem) => {
    const link = linkListItem.fields.mastheadLink;
    return {
        trackingAttributes: trackingAttributes(trackCat, link.fields.trackingId),
        href: link.fields.href,
        linkText: link.fields.title,
        level: linkListItem === null || linkListItem === void 0 ? void 0 : linkListItem.fields.nestingLevel,
        openInNewWindow: link.fields.target === 'blank',
    };
};
export const NavBarLinks = ({ mastheadData, colors, entries }) => {
    return (React.createElement(StyledNavBar, { list: React.createElement("nav", { dir: "ltr" },
            React.createElement(StyledNavBarList, null, entries.filter(isNotUndefined).map((item, index) => {
                var _a;
                if (isMastheadLink(item)) {
                    return (React.createElement("li", { key: item.fields.trackingId },
                        React.createElement(NavLink, { href: item.fields.href, openInNewWindow: item.fields.target === 'blank', id: item.fields.htmlId, trackingAttributes: [trackCat, item.fields.trackingId], colors: colors }, item.fields.title)));
                }
                if (isMastheadLinkList(item)) {
                    return (React.createElement("li", { key: item.fields.label + index },
                        React.createElement(NavbarDropdown, { id: item.sys.id, colors: colors, label: item.fields.label, chevronCopy: {
                                open: mastheadData.fields.dropdownMenuLabelOpen,
                                closed: mastheadData.fields.dropdownMenuLabelClose,
                            }, popoverLinks: item.fields.entries
                                ?
                                    item.fields.entries
                                        .filter(isMastheadLinkListItem)
                                        .map(buildPopoverLinkItems)
                                : [] })));
                }
                if (isMastheadGalleryMenu(item) || isMastheadCategoryMenu(item)) {
                    return (React.createElement("li", { key: ((_a = item === null || item === void 0 ? void 0 : item.fields) === null || _a === void 0 ? void 0 : _a.label) + index },
                        React.createElement(SubmenuTrigger, { id: item.sys.id, colors: colors }, item.fields.label)));
                }
                return React.createElement("div", null);
            }))) }));
};
//# sourceMappingURL=Links.js.map